import { render, staticRenderFns } from "./CustomShortcut.vue?vue&type=template&id=6f65a694&scoped=true&"
import script from "./CustomShortcut.vue?vue&type=script&lang=js&"
export * from "./CustomShortcut.vue?vue&type=script&lang=js&"
import style0 from "./CustomShortcut.vue?vue&type=style&index=0&id=6f65a694&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f65a694",
  null
  
)

export default component.exports